import React, { useState } from "react";
import style from "./style.module.css";
import ImageIcon from "@mui/icons-material/Image";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Input } from "../../components/Input";
import { AutocompleteSelect } from "../../components/AutocompleteSelect";
import {
  Award_Types,
  Document_Types,
  Examination_Bodies,
  Gender_Type,
  Maritial_Status,
  RelationShip_Apllication,
  School_Types,
  Skill_Areas,
  Yearly_Awards,
} from "../../components/Constant/constants";
import { Country, State, City } from "country-state-city";
import CloseIcon from "@mui/icons-material/Close";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { addProgrammeApplication, uploadFileAws } from "../../Api/commonApi";
import { useLocation } from "react-router-dom";
import { loader, toast } from "../../store/utilities";

export default function ProgrammeApply() {
  const locationData = useLocation();
  console.log(locationData, "locationDataa");
  const [formData, setFormData] = useState({
    profile_image: {
      fileName: "",
      fileUrl: "",
    },
    first_name: "",
    last_name: "",
    middle_name: "",
    maiden_name: "",
    gender: "",
    dob: "",
    nationality: "",
    email: "",
    telephone_1: "",
    telephone_2: "",
    marital_status: "",
    special_needs: [],
    address_street: "",
    address_district: "",
    address_postal_zone: "",
    country: "",
    state: "",
    city: "",
    emergency_contact: {
      first_name: "",
      last_name: "",
      relationship: "",
      telephone_1: "",
      telephone_2: "",
    },
    programme_information: {
      programmeOffer_id: locationData?.state?.programmeData?._id,
      programme_id: locationData?.state?.fullData?._id,
      institute_id: locationData?.state?.programmeData?.institution_ids,
      previously_enrolled: "",
      someone_to_contact_you_to_discuss: "",
      How_did_you_learn_about_programme: "",
      other: "",
    },
    education_employment: {
      school_attended: [
        {
          school_name: "",
          school_type: "",
          start: "",
          end: "",
          award: "",
        },
      ],
      qualification: [
        {
          subject_skill_area: "",
          examination_body: "",
          award_type: "",
          grade_obtained: "",
          year_award: "",
        },
      ],
      currently_employed: "",
      curently_self_employed: "",
      if_No_ever_been_employed_self_employed: "",
      have_any_experience_this_programme: "",
      have_any_experience_other: "",
      if_yes_please_sepcify: "",
    },
    document_type: "",
    document: {
      fileName: "",
      fileUrl: "",
    },
    email_verify: "",
    lmis_id: locationData?.state?.fullData?.lmis_id,
  });

  const [Validation, setValidation] = useState({
    first_name: "",
    last_name: "",
    maiden_name: "",
    gender: "",
    dob: "",
    nationality: "",
    email: "",
    telephone_1: "",
    telephone_2: "",
    marital_status: "",
    special_needs: [],
    address_street: "",
    address_district: "",
    address_postal_zone: "",
    country: "",
    image: "",
    emergency_contact_first_name: "",
    emergency_contact_last_name: "",
    emergency_contact_relationship: "",
    emergency_contact_telephone_1: "",
    emergency_contact_telephone_2: "",
    document_type:"",
    image_document: "",
  });

  const checkValidation = () => {
    let isValid = true;
    let newValidation = { ...Validation };

    // Check each field
    if (!formData.first_name) {
      newValidation.first_name = true;
      isValid = false;
    }
    if (!formData.last_name) {
      newValidation.last_name = true;
      isValid = false;
    }
    if (!formData.maiden_name) {
      newValidation.maiden_name = true;
      isValid = false;
    }
    if (!formData.gender) {
      newValidation.gender = true;
      isValid = false;
    }
    if (!formData.dob) {
      newValidation.dob = true;
      isValid = false;
    }
    if (!formData.nationality) {
      newValidation.nationality = true;
      isValid = false;
    }
    if (!formData.email) {
      newValidation.email = true;
      isValid = false;
    }
    if (!formData.telephone_1) {
      newValidation.telephone_1 = true;
      isValid = false;
    }
    if (!formData.telephone_2) {
      newValidation.telephone_2 = true;
      isValid = false;
    }
    if (!formData.marital_status) {
      newValidation.marital_status = true;
    }
    if (!formData.address_street) {
      newValidation.address_street = true;
    }
    if (!formData.address_district) {
      newValidation.address_district = true;
    }
    if (!formData.address_postal_zone) {
      newValidation.address_postal_zone = true;
    }
    if (!formData.country) {
      newValidation.country = true;
    }
    if (!previewUrl) {
      newValidation.image = true;
      isValid = false;
    }


    if (!formData.emergency_contact.first_name) {
      newValidation.emergency_contact_first_name = true;
    }
    if (!formData.emergency_contact.last_name) {
      newValidation.emergency_contact_last_name = true;
    }
    if (!formData.emergency_contact.relationship) {
      newValidation.emergency_contact_relationship = true;
    }
    if (!formData.emergency_contact.telephone_1) {
      newValidation.emergency_contact_telephone_1 = true;
      isValid = false;
    }
    if (!formData.emergency_contact.telephone_2) {
      newValidation.emergency_contact_telephone_2 = true;
      isValid = false;
    }
    if (!formData.document_type) {
      newValidation.document_type = true;
      isValid = false;
    }
    if (!fileName) {
      newValidation.image_document = true;
      isValid = false;
    }

    setValidation(newValidation);
    return isValid;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value === " ") {
      e.target.value = "";
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleInputObject = (objectName, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [objectName]: { ...prev[objectName], [field]: value },
    }));
  };

  const handleCheckboxChange = (checked, value) => {
    setFormData((prev) => ({
      ...prev,
      special_needs: checked
        ? [...prev.special_needs, value] // Add to array if checked
        : prev.special_needs.filter((item) => item !== value), // Remove if unchecked
    }));
  };
  const [previewUrl, setPreviewUrl] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const countries = Country.getAllCountries();
  const [selectedCountry, setSelectedCountry] = useState(
    countries.map((res) => ({
      label: res.name,
      value: res.name,
    }))
  );

  const [selectedCountry1, setSelectedCountry1] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  // const handleCountryChange = (event) => { 
  // };

  const handleCountryChange1 = (event, state) => {
    const countryCode = event;
    setSelectedCountry1(countryCode);
    setSelectedState(""); // Reset state when country changes
    setSelectedCity(""); // Reset city when country changes
    setFormData((prev) => ({
      ...prev,
      country: countries.find((e) => e.isoCode === countryCode)?.name,
      state: "",
      city: "",
    }));
    let stateList = State.getStatesOfCountry(countryCode);
    setStates(stateList);
    if (state) {
      let stateInfo = stateList.find((e) => e.name === state);
      handleStateChange(stateInfo.isoCode, countryCode);
    }
  };

  const handleStateChange = (event, code) => {
    const stateCode = event;
    console.log(stateCode);
    setSelectedState(stateCode);
    setSelectedCity(""); // Reset city when state changes
    setFormData((prev) => ({
      ...prev,
      state: states.find((e) => e.isoCode === stateCode)?.name,
      city: "",
    }));

    setCities(City.getCitiesOfState(code ? code : selectedCountry1, stateCode));
  };

  // Handle city change
  const handleCityChange = (event) => {
    const cityName = event.target.value;
    setSelectedCity(cityName);
    setFormData((prev) => ({
      ...prev,
      city: cityName,
    }));
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      const preview = URL.createObjectURL(file);
      setPreviewUrl(preview);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          profile_image: {
            fileName: file.name,
            fileUrl: reader.result,
          },
        }));
      };
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setPreviewUrl("");
    setFormData((prev) => ({
      ...prev,
      profile_image: { fileName: "", fileUrl: "" },
    }));
  };

  const [units, setUnits] = useState([
    { school_name: "", school_type: "", start: "", end: "", award: "" },
  ]);
  const addUnit = () => {
    setUnits([
      ...units,
      { school_name: "", school_type: "", start: "", end: "", award: "" },
    ]);
  };

  const removeUnit = (index) => {
    setUnits(units.filter((_, i) => i !== index));
  };

  const handleUnitChange = (index, field, value) => {
    const updatedUnits = [...units];
    updatedUnits[index][field] = value;
    setUnits(updatedUnits);
  };

  const [Listof, setListOf] = useState([
    {
      subject_skill_area: "",
      examination_body: "",
      award_type: "",
      grade_obtained: "",
      year_award: "",
    },
  ]);
  const addlistOf = () => {
    setListOf([
      ...Listof,
      {
        subject_skill_area: "",
        examination_body: "",
        award_type: "",
        grade_obtained: "",
        year_award: "",
      },
    ]);
  };
  const removeListOf = (index) => {
    setListOf(Listof.filter((_, i) => i !== index));
  };

  const handleListOfChange = (index, field, value) => {
    const updatedUnits = [...Listof];
    updatedUnits[index][field] = value;
    setListOf(updatedUnits);
  };

  const [fileName, setFileName] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileName(file ? file : "No file chosen");
  };

  const addProgrammeApplyForm = async (e) => {
    e.preventDefault();
    if (!checkValidation()) {
      console.log("Validation failed");
      return;
    }
    loader.start();
    try {
      let payload = {
        ...formData,
        education_employment: {
          ...formData.education_employment,
          school_attended: units,
          qualification: Listof,
        },
      };

      if (selectedImage) {
        const formDatainfo = new FormData();
        formDatainfo.append("upload", selectedImage);
        let image = await uploadFileAws(formDatainfo).then(
          (res) => res.data.data
        );
        payload.profile_image.fileName = image.file_name;
        payload.profile_image.fileUrl = image.file_url;
      }
      if (fileName) {
        const formDatainfo = new FormData();
        formDatainfo.append("upload", fileName);
        let image = await uploadFileAws(formDatainfo).then(
          (res) => res.data.data
        );
        payload.document.fileName = image.file_name;
        payload.document.fileUrl = image.file_url;
      }

      const response = await addProgrammeApplication(payload);
      toast.success("Programme form apply successfully");
      console.log(response);
    } catch (err) {
      console.log(err);
    } finally {
      loader.stop();
    }
  };

  return (
    <>
      <div className={style.mainContainer}>
        <div className={`${style.main_heading_style_programmeApply}`}>
          Online Application
        </div>
        <div className={`${style.programme_Apply_subheading}`}>
          Instructions
        </div>
        <div className="mt-3">
          Please read the instructions below for completing your application for
          admission.
        </div>
        <div className="mt-3">
          1. Only one application is required per applicant.
        </div>
        <div>
          2. Ensure that the application is FULLY completed using CAPITAL
          letters for legibility. Forms not properly completed will not be
          processed. All sections must be completed, however, for sections not
          applicable please indicate “N/A”.
        </div>
        <div>
          3. A valid working email address and one mobile phone number are
          mandatory*{" "}
        </div>
        <div>
          4. Applicants are responsible for ensuring that all supporting
          documents are submitted with this form.
        </div>
        <div className="d-flex justify-content-start mt-4">
          <label className={style.label_upload}>
            Upload Image<span className="text-danger">*</span>
          </label>
        </div>
        <form onSubmit={addProgrammeApplyForm}>
          <div className="d-flex justify-content-start mt-4">
            {previewUrl ? (
              <div style={{ marginBottom: "24px" }}>
                <img
                  src={previewUrl}
                  alt="Preview"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    border: "4px solid #1890ff",
                    objectFit: "cover",
                  }}
                />
                <br />
                <button
                  onClick={handleRemoveImage}
                  style={{
                    marginTop: "16px",
                    padding: "10px 20px",
                    fontSize: "14px",
                    backgroundColor: "#ff4d4f",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    boxShadow: "0px 4px 10px rgba(255, 77, 79, 0.2)",
                    transition: "background-color 0.3s",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.backgroundColor = "#d9363e")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.backgroundColor = "#ff4d4f")
                  }
                >
                  Remove Image
                </button>
              </div>
            ) : (
              <>
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  id="file-input"
                  onChange={handleImageChange}
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, image: false }))
                  }
                />
                <label
                  htmlFor="file-input"
                  style={{
                    display: "inline-block",
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    color: "#999",
                    textAlign: "center",
                    lineHeight: "150px",
                    cursor: "pointer",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    transition: "background-color 0.3s",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.backgroundColor = "#e6f7ff")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.backgroundColor = "#f0f0f0")
                  }
                  className={Validation.image ? `border border-danger` : ""}
                >
                  <AccountCircleIcon
                    style={{
                      fontSize: "60px",
                      color: "#999",
                    }}
                  />
                </label>
              </>
            )}
          </div>
          <div
            className={`${style.section_personal_information_programm_apply} mt-3`}
          >
            Section A-Personal Information
          </div>
          <div className={`card ${style.section_A_personal_information}`}>
            <div className="mt-4">
              <div className={`${style.programme_Apply_subheading}`}>
                Personal Data
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label className={style.label}>
                  First Name<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter first name"
                  name="first_name"
                  onChange={handleInputChange}
                  className={
                    Validation.first_name
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, first_name: false }))
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>Middle Name</label>
                <Input
                  placeholder="Enter middle name"
                  name="middle_name"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  Last Name<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter last name"
                  name="last_name"
                  onChange={handleInputChange}
                  className={
                    Validation.last_name
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, last_name: false }))
                  }
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>
                  Maiden Name<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter maiden name"
                  name="maiden_name"
                  onChange={handleInputChange}
                  className={
                    Validation.maiden_name
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, maiden_name: false }))
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>Gender</label>
                <AutocompleteSelect
                  label={"Select gender"}
                  getOptionLabel={(option) => option.value || ""}
                  options={Gender_Type}
                  style={{
                    border: "1px solid white",
                    borderRadius: "8px",
                    backgroundColor: "white",
                  }}
                  onChange={(e, value) => {
                    handleInputChange({
                      target: {
                        name: "gender",
                        value: value?.value,
                      },
                    });
                    setValidation((prev) => ({
                      ...prev,
                      gender: false,
                    }));
                  }}
                  className={
                    Validation.gender
                      ? `${style.input} error_input_autocompleate`
                      : `${style.input}  `
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  D.O.B<span className="text-danger">*</span>
                </label>
                <Input
                  type="date"
                  placeholder="Enter last name"
                  name="dob"
                  onChange={handleInputChange}
                  className={
                    Validation.dob
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, dob: false }))
                  }
                />
              </div>
            </div>
            {/* <div className="row mt-2">
            <div className="col-md-4">
              <label className={style.label}>
                Maiden Name<span className="text-danger">*</span>
              </label>
              <Input placeholder="Enter first name" />
            </div>
            <div className="col-md-4">
              <label className={style.label}>Gender</label>
              <AutocompleteSelect
                label={"Select gender"}
                getOptionLabel={(option) => option.value || ""}
                options={Gender_Type}
                style={{
                  border: "1px solid white",
                  borderRadius: "8px",
                  backgroundColor: "white",
                }}
              />
            </div>
            <div className="col-md-4">
              <label className={style.label}>
                D.O.B<span className="text-danger">*</span>
              </label>
              <Input type="date" placeholder="Enter last name" />
            </div>
          </div> */}
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>Nationality</label>
                <AutocompleteSelect
                  label={"Select nationality"}
                  getOptionLabel={(option) => option.label || ""}
                  options={selectedCountry}
                  style={{
                    border: "1px solid white",
                    borderRadius: "8px",
                    backgroundColor: "white",
                  }}
                  name="nationality"
                  onChange={(e,value) => {
                    setFormData((prev) => ({
                      ...prev,
                      nationality: value?.value,
                    }));
                    setValidation((prev) => ({
                      ...prev,
                      nationality: false,
                    }));
                  }}
                  className={
                    Validation.nationality
                      ? `${style.input} error_input_autocompleate`
                      : `${style.input}  `
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>Email</label>
                <Input
                  placeholder="Enter email"
                  type="email"
                  name="email"
                  onChange={handleInputChange}
                  className={
                    Validation.email
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, email: false }))
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  Telephone 1<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter telephone"
                  type="number"
                  name="telephone_1"
                  onChange={handleInputChange}
                  className={
                    Validation.telephone_1
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, telephone_1: false }))
                  }
                />
              </div>

              {/* <div className="col-md-4">
              <label className={style.label}>
                TRN<span className="text-danger">*</span>
              </label>
              <Input placeholder="Enter trn" />
            </div>

            <div className="col-md-4">
              <label className={style.label}>
                NIS<span className="text-danger">*</span>
              </label>
              <Input type="date" placeholder="Enter nis" />
            </div> */}
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>
                  Telephone 2<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter telephone"
                  type="number"
                  name="telephone_2"
                  onChange={handleInputChange}
                  className={
                    Validation.telephone_2
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, telephone_2: false }))
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>Marital Status</label>
                <AutocompleteSelect
                  label={"Select status"}
                  getOptionLabel={(option) => option?.value || ""}
                  options={Maritial_Status}
                  style={{
                    border: "1px solid white",
                    borderRadius: "8px",
                    backgroundColor: "white",
                  }}
                  onChange={(e, value) => {
                    handleInputChange({
                      target: {
                        name: "marital_status",
                        value: value?.value,
                      },
                    });
                    setValidation((prev) => ({
                      ...prev,
                      marital_status: false,
                    }));
                  }}
                  className={
                    Validation.marital_status
                      ? `${style.input} error_input_autocompleate`
                      : `${style.input}  `
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  Do you have Special Needs?
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex ">
                  <div className="d-flex">
                    <input
                      placeholder="Enter trn"
                      type="radio"
                      className="me-2"
                      id="radio1"
                      name="special_needs"
                      // onChange={(e) => {
                      //   setFormData((prev) => ({
                      //     ...prev,
                      //     special_needs: ["yes"],
                      //   }));
                      // }}
                      onChange={(e, value) => {
                        handleCheckboxChange(true, value, "yes");
                        handleCheckboxChange(false, value, "no");
                      }}
                    />

                    <label className={style.label_upload}>Yes</label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      placeholder="Enter nis"
                      type="radio"
                      className="me-2"
                      id="radio1"
                      name="special_needs"
                      // onChange={(e) => {
                      //   setFormData((prev) => ({
                      //     ...prev,
                      //     special_needs: ["no"],
                      //   }));
                      // }}
                      onChange={(e, value) => {
                        handleCheckboxChange(true, value, "no");
                        handleCheckboxChange(false, value, "yes");
                      }}
                    />

                    <label className={style.label_upload}>No</label>
                  </div>
                </div>
              </div>
            </div>
            {formData?.special_needs?.includes("yes") && (
              <div className="row mt-2">
                <div className="col-md-12">
                  <label className={style.label}>
                    If yes, Please Tick All That Apply
                    <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex ">
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        className="me-3 form-check-input"
                        id="radio9"
                        name="Physical"
                        onChange={(e, value) => {
                          handleCheckboxChange(
                            e.target.checked,
                            value,
                            "Physical"
                          );
                        }}
                      />

                      <label className={style.label_upload}>Physical</label>
                    </div>
                    <div className="d-flex ms-5">
                      <input
                        type="checkbox"
                        className="me-3 form-check-input"
                        id="radio9"
                        name="Emotional/Behavioral"
                        onChange={(e, value) => {
                          handleCheckboxChange(
                            e.target.checked,
                            value,
                            "Emotional/Behavioral"
                          );
                        }}
                      />

                      <label className={style.label_upload}>
                        Emotional/Behavioral
                      </label>
                    </div>
                    <div className="d-flex ms-5">
                      <input
                        type="checkbox"
                        className="me-3 form-check-input"
                        id="radio9"
                        name="Developmental/Learning"
                        onChange={(e, value) => {
                          handleCheckboxChange(
                            e.target.checked,
                            value,
                            "Developmental/Learning"
                          );
                        }}
                      />

                      <label className={style.label_upload}>
                        Developmental/Learning
                      </label>
                    </div>
                    <div className="d-flex ms-5">
                      <input
                        type="checkbox"
                        className="me-3 form-check-input"
                        id="radio9"
                        name="Sensory-Impaired"
                        onChange={(e, value) => {
                          handleCheckboxChange(
                            e.target.checked,
                            value,
                            "Sensory-Impaired"
                          );
                        }}
                      />

                      <label className={style.label_upload}>
                        Sensory-Impaired
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="mt-4">
              <div className={`${style.programme_Apply_subheading}`}>
                Permanent Address
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>Street</label>
                <Input
                  placeholder="Enter street"
                  type="text"
                  name="address_street"
                  onChange={handleInputChange}
                  className={
                    Validation.address_street
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, address_street: false }))
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  District<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter district"
                  name="address_district"
                  onChange={handleInputChange}
                  className={
                    Validation.address_district
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, address_district: false }))
                  }
                />
              </div>

              <div className="col-md-4">
                <label className={style.label}>
                  Postal Code<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter postal code"
                  name="address_postal_zone"
                  onChange={handleInputChange}
                  className={
                    Validation.address_postal_zone
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, address_postal_zone: false }))
                  }
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>Country</label>
                <select
                  // className="form-control"
                  id="country"
                  value={selectedCountry1}
                  onChange={(e) => handleCountryChange1(e.target.value)}
                  className={
                    Validation.country
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, country: false }))
                  }
                >
                  <option value="" style={{ fontSize: "14px" }}>
                    Select Country
                  </option>
                  {countries.map((country) => (
                    <option key={country.isoCode} value={country.isoCode}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label className={style.label}>State</label>
                <select
                  className="form-control"
                  id="state"
                  value={selectedState}
                  onChange={(e) => handleStateChange(e.target.value)}
                >
                  <option value="" style={{ fontSize: "14px" }}>
                    Select State
                  </option>
                  {states.map((state) => (
                    <option key={state.isoCode} value={state.isoCode}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label className={style.label}>city</label>
                <select
                  className="form-control"
                  id="city"
                  value={selectedCity}
                  onChange={handleCityChange}
                >
                  <option value="" style={{ fontSize: "14px" }}>
                    Select City
                  </option>
                  {cities.map((city) => (
                    <option key={city.name} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="mt-4">
              <div className={`${style.programme_Apply_subheading}`}>
                Emergency Contact
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>
                  First Name<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter first name"
                  onChange={(e) => {
                    handleInputObject(
                      "emergency_contact",
                      "first_name",
                      e.target.value
                    );
                  }}
                  className={
                    Validation.emergency_contact_first_name
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, emergency_contact_first_name: false }))
                  }
                />
              </div>

              <div className="col-md-4">
                <label className={style.label}>
                  Last Name<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter last name"
                  onChange={(e) => {
                    handleInputObject(
                      "emergency_contact",
                      "last_name",
                      e.target.value
                    );
                  }}
                  className={
                    Validation.emergency_contact_last_name
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, emergency_contact_last_name: false }))
                  }
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  Relationship to Application
                </label>
                <AutocompleteSelect
                  label={"Select gender"}
                  getOptionLabel={(option) => option.value || ""}
                  options={RelationShip_Apllication}
                  name="relationship"
                  style={{
                    border: "1px solid white",
                    borderRadius: "8px",
                    backgroundColor: "white",
                  }}
                  onChange={(value) => {
                    handleInputObject(
                      "emergency_contact",
                      "relationship",
                      value?.value
                    );
                    setValidation((prev) => ({
                      ...prev,
                      emergency_contact_relationship: false,
                    }));
                  }}
                  className={
                    Validation.marital_status
                      ? `${style.input} error_input_autocompleate`
                      : `${style.input}  `
                  }
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>
                  Telephone 1<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter telephone"
                  onChange={(e) => {
                    handleInputObject(
                      "emergency_contact",
                      "telephone_1",
                      e.target.value
                    );
                  }}
                  className={
                    Validation.emergency_contact_telephone_1
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, emergency_contact_telephone_1: false }))
                  }
                />
              </div>

              <div className="col-md-4">
                <label className={style.label}>
                  Telephone 2<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter telephone"
                  onChange={(e) => {
                    handleInputObject(
                      "emergency_contact",
                      "telephone_2",
                      e.target.value
                    );
                  }}
                  className={
                    Validation.emergency_contact_telephone_2
                      ? `${style.input} error_input form-control`
                      : `${style.input} form-control `
                  }
                  onClick={() =>
                    setValidation((prev) => ({ ...prev, emergency_contact_telephone_2: false }))
                  }
                />
              </div>
            </div>
          </div>
          <div
            className={`${style.section_personal_information_programm_apply}`}
          >
            Section B-Programme Information
          </div>
          <div className={`card ${style.section_A_personal_information}`}>
            <div className="mt-4">
              <div className={`${style.programme_Apply_subheading}`}>
                Programme Information
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>
                  Programme offering of Choice
                </label>
                <input
                  className="form-control"
                  value={locationData?.state?.fullData?.name}
                  disabled
                />
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  Name of Training Provider
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  value={locationData?.state?.programmeData?.institute_name}
                  disabled
                />
              </div>

              <div className="col-md-4">
                <label className={style.label}>Programme Reward</label>
                <input
                  className="form-control"
                  value={locationData?.state?.fullData?.award}
                  disabled
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <label className={style.label}>Start Date</label>
                <input
                  className="form-control"
                  value={locationData?.state?.programmeData?.duration?.from}
                  disabled
                />
              </div>

              <div className="col-md-4">
                <label className={style.label}>End Date</label>
                <input
                  className="form-control"
                  value={locationData?.state?.programmeData?.duration?.to}
                  disabled
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <label className={style.label}>
                  Have You Previously Enrolled at the LMIS
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex ">
                  <div className="d-flex">
                    <input
                      placeholder="Enter trn"
                      type="radio"
                      className="me-2"
                      id="radio2"
                      name="previously_enrolled"
                      onChange={(e) => {
                        handleInputObject(
                          "programme_information",
                          "previously_enrolled",
                          true
                        );
                      }}
                    />
                    <label className={style.label_upload}>Yes</label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      placeholder="Enter nis"
                      type="radio"
                      className="me-2"
                      id="radio2"
                      name="previously_enrolled"
                      onChange={(e) => {
                        handleInputObject(
                          "programme_information",
                          "previously_enrolled",
                          false
                        );
                      }}
                    />
                    <label className={style.label_upload}>No</label>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <label className={style.label}>
                  Would You Like Someone To Contact You To Discuss Your Needs?
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex ">
                  <div className="d-flex">
                    <input
                      placeholder="Enter trn"
                      type="radio"
                      className="me-2"
                      id="radio3"
                      name="someone_to_contact_you_to_discuss"
                      onChange={(e) => {
                        handleInputObject(
                          "programme_information",
                          "someone_to_contact_you_to_discuss",
                          true
                        );
                      }}
                    />
                    <label className={style.label_upload}>Yes</label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      placeholder="Enter nis"
                      type="radio"
                      className="me-2"
                      id="radio3"
                      name="someone_to_contact_you_to_discuss"
                      onChange={(e) => {
                        handleInputObject(
                          "programme_information",
                          "someone_to_contact_you_to_discuss",
                          false
                        );
                      }}
                    />
                    <label className={style.label_upload}>No</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <label className={style.label}>
                How Did You Learn About The Lmis Programme?
                <span className="text-danger">*</span>
              </label>
              <div className="col-md-4">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="me-3 form-check-input"
                    onChange={(e) => {
                      handleInputObject(
                        "programme_information",
                        "How_did_you_learn_about_programme",
                        e.target.checked
                      );
                    }}
                  />
                  <label className={style.label_upload}>Lmis Website</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="me-3 form-check-input"
                    onChange={(e) => {
                      handleInputObject(
                        "programme_information",
                        "How_did_you_learn_about_programme",
                        e.target.checked
                      );
                    }}
                  />
                  <label className={style.label_upload}>School</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="me-3 form-check-input"
                    onChange={(e) => {
                      handleInputObject(
                        "programme_information",
                        "How_did_you_learn_about_programme",
                        e.target.checked
                      );
                    }}
                  />
                  <label className={style.label_upload}>Radio</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="me-3 form-check-input"
                    onChange={(e) => {
                      handleInputObject(
                        "programme_information",
                        "How_did_you_learn_about_programme",
                        e.target.checked
                      );
                    }}
                  />
                  <label className={style.label_upload}>Tv</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="me-3 form-check-input"
                    onChange={(e) => {
                      handleInputObject(
                        "programme_information",
                        "How_did_you_learn_about_programme",
                        e.target.checked
                      );
                    }}
                  />
                  <label className={style.label_upload}>Social Media</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="me-3 form-check-input"
                    onChange={(e) => {
                      handleInputObject(
                        "programme_information",
                        "How_did_you_learn_about_programme",
                        e.target.checked
                      );
                    }}
                  />
                  <label className={style.label_upload}>Family/Friends</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="me-3 form-check-input"
                    onChange={(e) => {
                      handleInputObject(
                        "programme_information",
                        "How_did_you_learn_about_programme",
                        e.target.checked
                      );
                    }}
                  />
                  <label className={style.label_upload}>Mobile App</label>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4">
                <label className={style.label}>
                  Other (Please Specify)<span className="text-danger">*</span>
                </label>
                <Input
                  placeholder="Enter Other"
                  onChange={(e) => {
                    handleInputObject(
                      "programme_information",
                      "other",
                      e.target.value
                    );
                    console.log(e.target.value)
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className={`${style.section_personal_information_programm_apply}`}
          >
            Section C-Education And Employment Information
          </div>
          <div className={`card ${style.section_A_personal_information}`}>
            <div className="mt-4">
              <div className={`${style.programme_Apply_subheading}`}>
                Education & Formal Qualification
              </div>
            </div>
            <div className="mt-3">
              (In addition to submitting a copy of your qualifications, please
              list qualifications including any diagnostics test, CVQ/NVQ-J
              Certificates, and other awards below.)
            </div>
            <div className="mt-4">
              <h6>CURRENT OR LAST SCHOOL ATTENDED</h6>
              {units.map((unit, index) => (
                <div key={index} className={style.unitContainer}>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <h6>School Information {index + 1}</h6>
                    <CloseIcon
                      className={style.removeIcon}
                      onClick={() => removeUnit(index)}
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label className={style.label}>
                        School Name
                      </label>
                      <Input
                        placeholder="Enter school Name"
                        name="school_name"
                        onChange={(e) => {
                          console.log(e.target.value, "school_name");
                          handleUnitChange(
                            index,
                            "school_name",
                            e.target.value
                          );
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className={style.label}>
                        School Type
                      </label>
                      <AutocompleteSelect
                        label={"Select school type"}
                        getOptionLabel={(option) => option.label || ""}
                        options={School_Types}
                        style={{
                          border: "1px solid white",
                          borderRadius: "8px",
                          backgroundColor: "white",
                        }}
                        name="school_type"
                        onChange={(value) => {
                          // console.log(e.target.value, "school_type");
                          handleUnitChange(index, "school_type", value?.value);
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className={style.label}>
                        start Date
                      </label>
                      <Input
                        placeholder="Enter duration"
                        type="date"
                        value={unit.start}
                        name="start"
                        onChange={(e) => {
                          console.log(e.target.value, "start");
                          handleUnitChange(index, "start", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className={style.label}>
                        End Date
                      </label>
                      <Input
                        placeholder="Enter unit description"
                        type="date"
                        // value={unit.end}
                        name="end"
                        onChange={(e) => {
                          handleUnitChange(index, "end", e.target.value);
                        }}
                        // className={
                        //   Validation.unit_description
                        //     ? `${style.input} error_input form-control`
                        //     : `${style.input} form-control `
                        // }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className={style.label}>
                        Award
                      </label>
                      <AutocompleteSelect
                        label={"Select award"}
                        getOptionLabel={(option) => option.label || ""}
                        options={Award_Types}
                        style={{
                          border: "1px solid white",
                          borderRadius: "8px",
                          backgroundColor: "white",
                        }}
                        name="award"
                        onChange={(value) => {
                          handleUnitChange(index, "award", value?.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="btn_primary_two mt-3"
                onClick={addUnit}
              >
                Add
              </button>
            </div>
            <div className="mt-4">
              <h6>LIST YOUR QUALIFICATIONS</h6>
              {Listof.map((unit, index) => (
                <div key={index} className={style.unitContainer}>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <h6>Qualification Information {index + 1}</h6>
                    <CloseIcon
                      className={style.removeIcon}
                      onClick={() => removeListOf(index)}
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label className={style.label}>
                        Subject/Skills Area
                        
                      </label>
                      <AutocompleteSelect
                        label={"Select skills area"}
                        getOptionLabel={(option) => option.label || ""}
                        options={Skill_Areas}
                        style={{
                          border: "1px solid white",
                          borderRadius: "8px",
                          backgroundColor: "white",
                        }}
                        name="subject_skill_area"
                        onChange={(e, value) => {
                          console.log(e.target.value, "subject_skill_area");
                          handleListOfChange(
                            index,
                            "subject_skill_area",
                            value?.value
                          );
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className={style.label}>
                        Examination Body
                      </label>
                      <AutocompleteSelect
                        label={"Select exam body"}
                        getOptionLabel={(option) => option.value || ""}
                        options={Examination_Bodies}
                        style={{
                          border: "1px solid white",
                          borderRadius: "8px",
                          backgroundColor: "white",
                        }}
                        name="examination_body"
                        onChange={(e, value) => {
                          handleListOfChange(
                            index,
                            "examination_body",
                            value?.value
                          );
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className={style.label}>
                        Qualification/Award Type
                        
                      </label>
                      <Input
                        placeholder="Enter award type"
                        type="text"
                        // value={unit.duration}
                        name="award_type"
                        onChange={(e) => {
                          handleListOfChange(
                            index,
                            "award_type",
                            e.target.value
                          );
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className={style.label}>
                        Grade Obtained
                      </label>
                      <Input
                        placeholder="Enter grade obtained"
                        // value={unit.unit_description}
                        name="grade_obtained"
                        onChange={(e) => {
                          handleListOfChange(
                            index,
                            "grade_obtained",
                            e.target.vale
                          );
                        }}
                        // className={
                        //   Validation.unit_description
                        //     ? `${style.input} error_input form-control`
                        //     : `${style.input} form-control `
                        // }
                      />
                    </div>
                    <div className="col-md-3">
                      <label className={style.label}>
                        Year Award
                      </label>
                      <AutocompleteSelect
                        label={"Select award"}
                        getOptionLabel={(option) => option.label || ""}
                        options={Yearly_Awards}
                        style={{
                          border: "1px solid white",
                          borderRadius: "8px",
                          backgroundColor: "white",
                        }}
                        name="year_award"
                        onChange={(value) => {
                          handleListOfChange(index, "year_award", value?.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="btn_primary_two mt-3"
                onClick={addlistOf}
              >
                Add
              </button>
            </div>
            <div className="mt-4">
              <div className={`${style.programme_Apply_subheading}`}>
                EMPLOYMENT & EXPERIENCE
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4">
                <label className={style.label}>
                  Are You Currently Employed?
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex ">
                  <div className="d-flex">
                    <input
                      placeholder="Enter trn"
                      type="radio"
                      className="me-2"
                      id="radio4"
                      name="currently_employed"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "currently_employed",
                          true
                        );
                      }}
                    />
                    <label className={style.label_upload}>Yes</label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      placeholder="Enter nis"
                      type="radio"
                      className="me-2"
                      id="radio4"
                      name="currently_employed"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "currently_employed",
                          false
                        );
                      }}
                    />
                    <label className={style.label_upload}>No</label>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  Are You Curently Self-Employed?
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex ">
                  <div className="d-flex">
                    <input
                      placeholder="Enter trn"
                      type="radio"
                      className="me-2"
                      id="radio5"
                      name="curently_self_employed"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "curently_self_employed",
                          true
                        );
                      }}
                    />
                    <label className={style.label_upload}>Yes</label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      placeholder="Enter nis"
                      type="radio"
                      className="me-2"
                      id="radio5"
                      name="curently_self_employed"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "curently_self_employed",
                          false
                        );
                      }}
                    />
                    <label className={style.label_upload}>No</label>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  If No, Have You Ever Been Employed or Self-Employed?
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex ">
                  <div className="d-flex">
                    <input
                      placeholder="Enter trn"
                      type="radio"
                      className="me-2"
                      id="radio6"
                      name="if_No_ever_been_employed_self_employed"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "if_No_ever_been_employed_self_employed",
                          true
                        );
                      }}
                    />
                    <label className={style.label_upload}>Yes</label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      placeholder="Enter nis"
                      type="radio"
                      className="me-2"
                      id="radio6"
                      name="if_No_ever_been_employed_self_employed"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "if_No_ever_been_employed_self_employed",
                          false
                        );
                      }}
                    />
                    <label className={style.label_upload}>No</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4">
                <label className={style.label}>
                  Do You Have Any Experience In The Skill Area To Which You Are
                  Applying?
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex ">
                  <div className="d-flex">
                    <input
                      placeholder="Enter trn"
                      type="radio"
                      className="me-2"
                      id="radio7"
                      name="have_any_experience_this_programme"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "have_any_experience_this_programme",
                          true
                        );
                      }}
                    />
                    <label className={style.label_upload}>Yes</label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      placeholder="Enter nis"
                      type="radio"
                      className="me-2"
                      id="radio7"
                      name="have_any_experience_this_programme"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "have_any_experience_this_programme",
                          false
                        );
                      }}
                    />
                    <label className={style.label_upload}>No</label>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  Do You Have Any Experience In Any Skill Area Other Than The
                  One(s) Stated Above?
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex ">
                  <div className="d-flex">
                    <input
                      placeholder="Enter trn"
                      type="radio"
                      className="me-2"
                      id="radio8"
                      name="have_any_experience_other"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "have_any_experience_other",
                          true
                        );
                      }}
                    />
                    <label className={style.label_upload}>Yes</label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      placeholder="Enter nis"
                      type="radio"
                      className="me-2"
                      id="radio8"
                      name="have_any_experience_other"
                      onChange={(e) => {
                        handleInputObject(
                          "education_employment",
                          "have_any_experience_other",
                          false
                        );
                      }}
                    />
                    <label className={style.label_upload}>No</label>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <label className={style.label}>
                  If Yes, Please Sepcify
                  <span className="text-danger">*</span>
                </label>
                <Input
                  className=""
                  placeholder="Enter please sepcify"
                  name="if_yes_please_sepcify"
                  onChange={(e) => {
                    handleInputObject(
                      "education_employment",
                      "if_yes_please_sepcify",
                      e.target.value
                    );
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className={`${style.section_personal_information_programm_apply}`}
          >
            Section D-Supporting Documents
          </div>
          <div className={`card ${style.section_A_personal_information}`}>
            <div className="row-6">
              <div className="col-md-3">
                <label className={style.label}>
                  Document<span className="text-danger">*</span>
                </label>
                <AutocompleteSelect
                  label={"Select document"}
                  getOptionLabel={(option) => option.label || ""}
                  options={Document_Types}
                  style={{
                    border: "1px solid white",
                    borderRadius: "8px",
                    backgroundColor: "white",
                  }}
                  name="document_type"
                  onChange={(e, value) => {
                    handleInputChange({
                      target: {
                        name: "document_type",
                        value: value?.value,
                      },
                    });
                    setValidation((prev) => ({
                      ...prev,
                      document_type: false,
                    }));
                  }}
                  className={
                    Validation.document_type
                      ? `${style.input} error_input_autocompleate`
                      : `${style.input}  `
                  }
                />
              </div>
            </div>
            <div className="mt-4">
              <div className={`${style.programme_Apply_subheading}`}>
                APPLICANTS ARE RESPONSIBLE FOR ENSURING THAT ALL SUPPORTING
                DOCUMENTS ARE ATTACHED. APPLICATIONS WITHOUT THE ATTACHED
                REQUIRED SUPPORTING DOCUMENTS WILL NOT BE CONSIDERED AND SHALL
                BE DEEMED “INCOMPLETE”.
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-3">
                <EditNoteIcon style={{ fontSize: "100Px" }} />
                <div className={`${style.file_input}`}>
                  <input
                    type="file"
                    id="fileUpload"
                    onChange={handleFileChange}
                    onClick={() =>
                      setValidation((prev) => ({ ...prev, image_document: false }))
                    }
                    
                  />
                  <label htmlFor="fileUpload" className={Validation.image_document ? `error_input form-control` : `${style.file_label}`}>
                    Choose File
                  </label>
                  <span className={`${style.file_name}`}>{fileName.name}</span>
                </div>
              </div>
              <div className="col-md-6">
                <div>File Upload Requirements</div>
                <div className="mt-4">
                  <div> 1.File Type should be .pdf/.jpg/.jpeg/.png</div>
                  <div>
                    2.RECENT RESUME (COMPILED WITHIN THE LAST 6 MONTHS)-
                    APPLICABLE FOR ON-THE-JOB TRAINING OR ASSESSMENT ONLY
                  </div>
                  <div>
                    3.COPIES OF QUALIFICATIONS OF ACADEMIC ACHIEVEMENTS AS
                    INDICATED ON THE APPLICATION FORM IN SECTION C
                  </div>
                  <div>
                    4.PROOF OF AGE (1 COPY OF PASSPORT OR NATIONAL ID OR BIRTH
                    CERTIFICATE OR DRIVER’S LICENSE) (Required)
                  </div>

                  <div>5.COPY OF TAX REGISTRATION NUMBER (TRN) (Required)</div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${style.section_personal_information_programm_apply}`}
          >
            Section E-Signature
          </div>
          <div className={`card ${style.section_A_personal_information}`}>
            <div className="mt-4 d-flex justify-content-center">
              <div className={`${style.programme_Apply_subheading}`}>
                DECLARATION
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-center">
              <button type="button" className="btn_primary_two mt-3">
                View Privacy Policy
              </button>
            </div>

            <div className="row mt-3">
              <div className="col-md-12">
                <div className="d-flex">
                  <input type="checkbox" className="me-3 form-check-input" />
                  <label className={style.label_upload}>
                    I declare that all information submitted including this
                    application and any other supporting documents is my own
                    work, factually true, and honestly presented and that these
                    documents will become the property of the HEART/NSTA Trust
                    to which I am applying and will not be returned to me. I
                    understand that my application for admission may be canceled
                    should the information I have declared be false. (Required)
                  </label>
                </div>
              </div>
              <div className="col-md-12 mt-2">
                <div className="d-flex">
                  <input type="checkbox" className="me-3 form-check-input" />
                  <label className={style.label_upload}>
                    I agree to notify the HEART/NSTA Trust to which I am
                    applying immediately should there be any change to the
                    information requested in this application. (Required)
                  </label>
                </div>
              </div>
              <div className="col-md-12 mt-2">
                <div className="d-flex">
                  <input type="checkbox" className="me-3 form-check-input" />
                  <label className={style.label_upload}>
                    I understand that once my application has been submitted it
                    may not be altered in any way; I will need to contact the
                    HEART/NSTA Trust directly if I wish to provide additional
                    information or make changes. (Required)
                  </label>
                </div>
              </div>
              <div className="col-md-12 mt-2">
                <div className="d-flex">
                  <input type="checkbox" className="me-3 form-check-input" />
                  <label className={style.label_upload}>
                    I understand and agree that by submitting this form I have
                    consented to the practices described in the privacy
                    statement (Click the View Privacy Policy above) . (Required)
                  </label>
                </div>
              </div>
            </div>
            {/* <div className="row mt-3">
            <div className="col-md-4">
              <label className={style.label}>
                Enter Email Verification Code
                <span className="text-danger">*</span>
              </label>
              <Input
                placeholder="Enter email verification code"
                type="Enter email verification code"

               
              />
            </div>
            <div className="col-md-3 mt-4">
              <button type="button" className="btn_primary_two ">
                Re-Send Email Verification Code
              </button>
            </div>
          </div> */}
            <div className="col-md-3 mt-4">
              <button type="submit" className="btn_primary_one">
                Submit Application Form
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
